import React from 'react'
import axios from 'axios'
import { useQuery } from 'react-query'
import { api } from '@zing/shared/api/index'
import { GetFormat, IUseGet } from '../../../types/api/api.types'
import { PostFormat } from '../mutation/contracts'

export function useGet<T = unknown>(request: GetFormat, requestKey = 'simple-get', querySettings = {}): IUseGet {
  const { data, isLoading, isFetching, isSuccess, isError, error, refetch } = useQuery<T>(
    requestKey,
    async () => {
      const response =
        request.externCallFlag === true
          ? await axios.get(request?.url, request?.httpConfig)
          : await api.get(request?.url, request?.httpConfig)

      return response.data
    },
    querySettings
  )

  return { data, isLoading, isFetching, isSuccess, isError, error, refetch }
}

export function usePost<T = unknown>(request: PostFormat, requestKey = 'simple-post', querySettings = {}): IUseGet {
  const { data, isLoading, isFetching, isSuccess, isError, error, refetch } = useQuery<T>(
    requestKey,
    async () => {
      const response =
        request.isPublic === true
          ? await axios.post(request?.url, request?.data, request?.httpConfig)
          : await api.post(request?.url, request?.data, request?.httpConfig)

      return response.data
    },
    querySettings
  )

  return { data, isLoading, isFetching, isSuccess, isError, error, refetch }
}

export * from '../../../types/api/api.types'
